module.exports = __webpack_public_path__ + "static/media/developerActivity.87032608.svg";